"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
//
//
//
//
//
//
var _default = exports.default = {
  name: 'App',
  data: function data() {
    return {
      path: '/'
    };
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path.indexOf('redirect') !== -1) {
        this.$router.replace(to.path.replace(/.+?redirect/g, '/redirect'));
      }
    }
  }
};